import { render } from "./DFYReel.vue?vue&type=template&id=13d912ad&scoped=true"
import script from "./DFYReel.vue?vue&type=script&lang=js"
export * from "./DFYReel.vue?vue&type=script&lang=js"

import "./DFYReel.vue?vue&type=style&index=0&id=13d912ad&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13d912ad"]])

export default __exports__